<div class="canned-message">
  <p class="canned-message_text">{{message}}</p>
  <stxt-svg-icon
    class="send-icon"
    [iconConfig]="sendIcon">
  </stxt-svg-icon>
</div>
